const urls={
    auth:"/api/Auth/Login/LoginUser"
    
}

export default urls